import { mergeOptions } from '../default';

const componentsToExclude = ['promotion-banner'];

const options = mergeOptions({
  showSubscribeForm: false,
  sectionQuoteProps: { className: 'gap-5 md:gap-8 md:min-h-80', variant: 'secondary' },
  sectionQuoteImageProps: { className: 'md:absolute' },
  componentsToExclude,
  storeFinderVariant: 'secondary',
  specialQuoteCarousel: true,
  accountContactInformationType: 'Corporate contact information',
  seoConfig: { titleSuffixContent: 'bosspaints.be' },
  contactInfoConfig: {
    formVariant: 'tertiary',
    enableMap: true,
  },
  showNewsPages: true,
});

export default options;
